export function getExcelData(data, reportType) {
  let rows = [];
  data.forEach((elem, index) => {
    var dateObj = new Date(elem.date);
    var _known = {
      Nro: index + 1,
      Ip: elem.ip,
      Usuario: elem.user,
      Fecha: dateObj.toISOString(),
      "Tipo de Reporte": reportType.filter((e) => e.id === elem.reportType)[0].name,
    };
    rows.push(_known);
  });
  return rows;
}
